
import React from 'react';

interface KosherStampProps {
  className?: string;
  color?: string;
}

const KosherStamp: React.FC<KosherStampProps> = ({ className = "", color = "currentColor" }) => {
  return (
    <div className={`relative inline-block select-none ${className}`}>
      {/* 
         FIX: Added dir="ltr" to the svg tag. 
         This ensures the coordinate system (paths) doesn't flip based on page direction.
         The text elements handle their own RTL display.
      */}
      <svg 
        viewBox="0 0 300 200" 
        className="w-full h-full drop-shadow-sm opacity-90"
        style={{ color: color, fontFamily: '"Frank Ruhl Libre", serif' }}
        dir="ltr" 
      >
        <defs>
          {/* Adjusted paths: Moving curves outwards to create space for center text */}
          <path id="curveTop" d="M 45,80 Q 150,15 255,80" />
          {/* Lowered curveBottom to move text down */}
          <path id="curveBottom" d="M 45,135 Q 150,200 255,135" />
        </defs>

        {/* Outer Oval - Double Border */}
        <ellipse 
            cx="150" 
            cy="100" 
            rx="145" 
            ry="95" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="3" 
        />
         <ellipse 
            cx="150" 
            cy="100" 
            rx="138" 
            ry="88" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="1" 
            strokeDasharray="4,2"
        />

        {/* 
           Top Text - Curved 
           FIX: Added style={{ direction: 'rtl' }} to explicitly force RTL rendering 
           for the text content, fixing the iOS reverse-letter issue.
        */}
        <text width="300" className="font-bold text-[24px] tracking-widest" fill="currentColor" style={{ direction: 'rtl' }}>
          <textPath href="#curveTop" startOffset="50%" textAnchor="middle">
             בהשגחת הבד"ץ
          </textPath>
        </text>

        {/* Center Text - Main Rabbi Name */}
        <text x="150" y="105" textAnchor="middle" className="font-bold text-[34px]" fill="currentColor" style={{ direction: 'rtl' }}>
           הרב מרדכי גרוס
        </text>

        {/* Subtitle Center */}
        <text x="150" y="130" textAnchor="middle" className="text-[15px]" fill="currentColor" style={{ direction: 'rtl' }}>
           שליט"א
        </text>

        {/* Bottom Text - Curved */}
        <text width="300" className="font-bold text-[22px] tracking-wide" fill="currentColor" style={{ direction: 'rtl' }}>
          <textPath href="#curveBottom" startOffset="50%" textAnchor="middle">
             גאב"ד חניכי הישיבות
          </textPath>
        </text>

        {/* Decorative Stars/Dots inside */}
        <circle cx="20" cy="100" r="3" fill="currentColor" />
        <circle cx="280" cy="100" r="3" fill="currentColor" />
        
      </svg>
    </div>
  );
};

export default KosherStamp;
